const doc = [({"en":({"js":({"admin":({"sheet_layouts":({"show":({"remove_box_icon":({"the_box_was_removed":"The box was removed."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;